import React from 'react';

import OptableMain from '../optable/OptableMain';

import OptInColumnManager from './OptInColumnManager';
import OptInDataModel from './OptInDataModel';
import OptInSummaryView from './OptInSummaryView';

export class OptInMain extends OptableMain {
  constructor(props) {
    super(props);

    this.dataModel = new OptInDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new OptInColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  getDataGridRowClassName() {
    return 'pwx-opt-in-datagrid-row';
  }

  renderUsageSummaries() {
    return (
      <div>
        <OptInSummaryView
          dataModel={this.summaryDataModel}
          locale={this.locale}
        />
      </div>
    );
  }
}
